import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { Checkbox, CheckboxProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import styled from 'styled-components';

interface Props extends Partial<CheckboxProps> {
	className?: string;
	name: string;
}

const FormCheckbox = ({ className, name, ...props }: Props) => {
	const {
		field,
		fieldState: { error },
	} = useController({ name });

	return (
		<UIElementIdentifier identifier={TEST_ELEMENT_IDS.CHECKBOX}>
			<Checkbox
				checked={field.value}
				onClick={() => {
					field.onChange(!field.value);
				}}
				error={error?.message}
				{...props}
				className={className}
			/>
		</UIElementIdentifier>
	);
};
const _FormCheckboxExport = styled(FormCheckbox)``;

export { _FormCheckboxExport as FormCheckbox };
